/**
 * AddPlaybackTokenGeneratorCtrl controller
 * Add/Edit Playback Token Generator
 */

import { PLAYBACK_TOKEN_GENERATOR_TYPES } from 'app/core/constants'

/**
 * AddPlaybackTokenGeneratorCtrl controller
 *
 * @class AddPlaybackTokenGeneratorCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddPlaybackTokenGeneratorCtrl
 */
/* @ngInject */
export default function AddPlaybackTokenGeneratorCtrl ($uibModalInstance, ptg) {
  var vm = this

  /**
   * Playback Token Generators types
   *
   * @memberof mwApp/catchups.controller:AddPlaybackTokenGeneratorCtrl
   * @type {Object}
   */
  vm.token_generators_types = PLAYBACK_TOKEN_GENERATOR_TYPES

  /**
   * Playback Token Generator
   *
   * @memberof mwApp/settings.controller:AddPlaybackTokenGeneratorCtrl
   * @type {models.PlaybackTokenGenerator}
   */
  vm.ptg = ptg

  /**
   * isNew flag
   *
   * @memberof mwApp/settings.controller:AddPlaybackTokenGeneratorCtrl
   * @type {Boolean}
   */
  vm.isNew = ptg._isNew()

  /**
   * Create or edit Playback Token Generator, and close modal window afterwards
   *
   * @memberof mwApp/settings.controller:AddPlaybackTokenGeneratorCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    ptg._save(data => {
      if (!['FLUSSONIC', 'ONAPP', 'AKAMAI_EDGIO', 'MULTI_CDN', 'CDN77', 'CACHEFLY'].includes(data.playbackTokenGeneratorType)) {
        delete data.ignoreClientIp
      }
    })
      .then(
        () => $uibModalInstance.close(ptg)
      )
      .finally(vm.unsetDisable)
  }

  vm.changeType = function () {
    if (!vm.ptg.id) {
      vm.ptg.tokenTime = vm.ptg.playbackTokenGeneratorType === 'CACHEFLY' ? 14400 : 3600
    }
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/settings.controller:AddPlaybackTokenGeneratorCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
